"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Email = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _defaultTranslations = require("../constants/defaultTranslations");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _useTranslations = require("../hooks/useTranslations");
var _models = require("../models");
var _utils = require("../utils");
var _EmailForm = require("./EmailForm");
var _Feedback = require("./Feedback");
var _Loader = require("./Loader");
var _Localization = require("./Localization");
var _jsxRuntime = require("react/jsx-runtime");
const GridStyled = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  alignItems: 'center',
  justifyContent: 'space-between'
}));
const PenIcon = (0, _mui.styled)(_icons.Pen)({
  fontSize: '25px'
});
const TypographyVerifyLink = (0, _mui.styled)(_mui.Typography)({
  display: 'inline',
  cursor: 'pointer',
  textDecoration: 'underline'
});
const TypographyContent = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '185px',
  [theme.breakpoints.up('sm')]: {
    width: '350px'
  }
}));
const TypographyTempEmail = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  color: theme.palette.text.disabled,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '185px',
  [theme.breakpoints.up('sm')]: {
    width: '350px'
  }
}));
const Email = props => {
  const [isEditing, setEditing] = (0, _react.useState)(false);
  const [typeEditEmail, setTypeEditEmail] = (0, _react.useState)(undefined);
  const [displayFeedback, setDisplayFeedback] = (0, _react.useState)(_models.DisplayFeedback.Hidden);
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const [isDisabledResend, setIsDisabledResend] = (0, _react.useState)(false);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    setScrollTop,
    sectionType,
    currentCustomerId
  } = props;
  const {
    customerId
  } = (0, _auth.useToken)();
  const selectedCustomerId = currentCustomerId ?? customerId;
  const {
    data: metadata
  } = (0, _globalApiClientReact.useGetCustomerEmailsMetadata)(selectedCustomerId, {}, {
    swr: {
      revalidateOnFocus: false
    }
  });
  const {
    data: emailData,
    isLoading
  } = (0, _globalApiClientReact.useGetCustomerEmails)(selectedCustomerId, {}, {
    swr: {
      revalidateOnFocus: false
    }
  });
  const globalApi = (0, _globalApiClientReact.useApiClient)();
  const currentEmail = emailData?.emails.find(email => !email.isPending)?.emailAddress;
  const tempEmail = emailData?.emails.find(email => email.isPending)?.emailAddress;
  const operations = metadata?.operations;
  const isEditEnabled = operations?.update?.isEnabled ?? false;
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing --- we need or
  const isEmail = currentEmail || tempEmail;
  const handleOpenEdit = type => {
    setTypeEditEmail(type);
    setEditing(true);
    setScrollTop?.('email');
  };
  const hideEdit = () => {
    setEditing(false);
  };
  const onDeleteEmail = feedbackStatus => {
    setEditing(false);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (feedbackStatus) {
      setDisplayFeedback(_models.DisplayFeedback.Delete);
    }
  };
  (0, _hooks.useHideFormOnCustomerIdChange)(hideEdit, selectedCustomerId, isEditing);
  const renderForm = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmailForm.EmailForm, {
    ...props,
    typeEmail: typeEditEmail,
    hideFormHandler: () => hideEdit(),
    onDeleteEmail: onDeleteEmail
  });
  const verifyEmail = async () => {
    try {
      const response = await (0, _globalApiClientReact.updateCustomerEmailVerificationRequest)(globalApi, selectedCustomerId, tempEmail ?? '', {
        requestStatus: 'Pending'
      });
      const result = new _models.FetchResult(response.status);
      if (result.isSuccess()) {
        if (!isDisabledResend && tempEmail) {
          (0, _utils.disableEmailResendVerification)(setIsDisabledResend);
        }
        setNotificationData({
          isOpen: true,
          message: formatMessage(_models.TranslationKey.infoConfirmDialog),
          type: 'success'
        });
      }
    } catch (error) {
      setNotificationData({
        isOpen: true,
        message: formatMessage(_models.TranslationKey.cannotUpdate),
        type: 'error'
      });
    }
  };
  const sendEmailLink = /*#__PURE__*/(0, _jsxRuntime.jsx)(TypographyVerifyLink, {
    "data-testid": getTestId('send-email-again-button'),
    onClick: () => verifyEmail(),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.sendAgain,
      defaultMessage: _defaultTranslations.defaultTranslations.sendAgain
    })
  });
  const displayMode = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(GridStyled, {
      container: true,
      mb: sectionType === _models.SectionType.Profile ? 4 : 0,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
        size: {
          xs: 12
        },
        children: currentEmail && tempEmail && sectionType === _models.SectionType.Profile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          align: "left",
          fontWeight: "bold",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.currentEmailTitle,
            defaultMessage: _defaultTranslations.defaultTranslations.currentEmailTitle
          })
        }) : null
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
        children: currentEmail ? /*#__PURE__*/(0, _jsxRuntime.jsx)(TypographyContent, {
          variant: "body1",
          textAlign: "left",
          children: currentEmail
        }) : null
      }), sectionType === _models.SectionType.Profile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
        children: isEditEnabled && currentEmail ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
            variant: "text",
            color: "default",
            "data-testid": getTestId(`email-edit-button`),
            onClick: () => handleOpenEdit('current'),
            "aria-label": formatMessage(_models.TranslationKey.edit),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PenIcon, {})
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
              id: _models.TranslationKey.edit,
              defaultMessage: _defaultTranslations.defaultTranslations.edit
            })
          })]
        }) : null
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(GridStyled, {
      container: true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
        size: {
          xs: 12
        },
        children: currentEmail && tempEmail && sectionType === _models.SectionType.Profile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(TypographyTempEmail, {
          variant: "body1",
          align: "left",
          fontWeight: "bold",
          color: "inherit",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.pendingEmail,
            defaultMessage: _defaultTranslations.defaultTranslations.pendingEmail
          })
        }) : null
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
        children: tempEmail && sectionType === _models.SectionType.Profile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(TypographyTempEmail, {
          variant: "body1",
          color: "inherit",
          "data-testid": getTestId('temp-email'),
          children: tempEmail
        }) : !currentEmail && tempEmail ? /*#__PURE__*/(0, _jsxRuntime.jsx)(TypographyTempEmail, {
          variant: "body1",
          color: "inherit",
          "data-testid": getTestId('temp-email'),
          children: tempEmail
        }) : null
      }), isEditEnabled && tempEmail && sectionType === _models.SectionType.Profile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
            variant: "text",
            color: "default",
            "data-testid": getTestId(`email-edit-button`),
            onClick: () => handleOpenEdit('temp'),
            "aria-label": formatMessage(_models.TranslationKey.edit),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PenIcon, {})
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
              id: _models.TranslationKey.edit,
              defaultMessage: _defaultTranslations.defaultTranslations.edit
            })
          })]
        })
      }) : null, tempEmail ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
        size: {
          xs: 12
        },
        mt: 2,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Alert, {
          children: isDisabledResend ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.disabledVerificationEmail,
            defaultMessage: _defaultTranslations.defaultTranslations.disabledVerificationEmail
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.waitingConfirmationEmail,
            defaultMessage: _defaultTranslations.defaultTranslations.waitingConfirmationEmail,
            values: {
              link: sendEmailLink
            }
          })
        })
      }) : null]
    })]
  });
  const isEditOrEmptyMode = Boolean(!isEmail || isEditing);
  const isDisplayMode = Boolean(isEmail && !isEditing);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [isDisplayMode ? displayMode() : null, isEditOrEmptyMode ? renderForm() : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Feedback.Feedback, {
      displayFeedback: displayFeedback,
      closeFeedback: () => setDisplayFeedback(_models.DisplayFeedback.Hidden)
    }), isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.Loader, {}) : null]
  });
};
exports.Email = Email;
